import { render, staticRenderFns } from "./detail-inventory-list.vue?vue&type=template&id=25e61fa6"
import script from "./detail-inventory-list.vue?vue&type=script&lang=js"
export * from "./detail-inventory-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports